/**
 * @generated SignedSource<<8f3bafcb10f68f21b62cadc5fae27824>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type summary_softwareReleasesVersionDetailIssueList_jiraIssue$data = {
  readonly key: string;
  readonly " $fragmentType": "summary_softwareReleasesVersionDetailIssueList_jiraIssue";
};
export type summary_softwareReleasesVersionDetailIssueList_jiraIssue$key = {
  readonly " $data"?: summary_softwareReleasesVersionDetailIssueList_jiraIssue$data;
  readonly " $fragmentSpreads": FragmentRefs<"summary_softwareReleasesVersionDetailIssueList_jiraIssue">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "summary_softwareReleasesVersionDetailIssueList_jiraIssue",
  "selections": [
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "key"
      },
      "action": "THROW",
      "path": "key"
    }
  ],
  "type": "JiraIssue"
};

(node as any).hash = "be0a5b93419942c75fd2d852a9d5c8fc";

export default node;
